import React from 'react';
import { Eye, ShieldCheck } from 'lucide-react';
import { fmtWhen } from '../../lib/chatsView';

/*
 * r16p (design 5.6 / 7.1): opening a thread on the phone shows the sender "Seen" on Instagram. The page says so, per thread:
 * "Read by the worker at HH:MM (Instagram showed it as Seen)", and for a verify-open (the worker opened the thread only to prove who
 * it is with, before a queued reply): "The worker opened the thread to check who it is with". Nothing is drawn for a thread the
 * worker has only seen in the inbox list (the preview tier marks nothing).
 */
export default function SeenNotice({ thread, now }) {
  if (!thread || !thread.seenAt) return null;
  const when = fmtWhen(thread.seenAt, now);
  if (thread.verifyOnly) {
    return (
      <p className="flex items-start gap-1.5 text-xs text-muted-foreground" data-testid="seen-notice" data-kind="verify">
        <ShieldCheck className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
        <span>The worker opened the thread {when} to check who it is with (Instagram showed it as Seen).</span>
      </p>
    );
  }
  return (
    <p className="flex items-start gap-1.5 text-xs text-muted-foreground" data-testid="seen-notice" data-kind="read">
      <Eye className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>Read by the worker {when} (Instagram showed it as Seen).</span>
    </p>
  );
}
